import { UploadedFile } from './uploadedFile';
import { Address } from './user';

type BuilderStep = 'landing' | 'intro' | 'path' | 'playground' | 'review';

enum RfqSuitabilityDecision {
  ACCEPT = 'ACCEPT',
  REVIEW = 'REVIEW',
  REJECT = 'REJECT'
}

interface RfqSuitabilityFilter {
  decision: RfqSuitabilityDecision;
  reasoning: string;
}

interface Rfq {
  rfq: {
    id: number;
    author: number;
    document: {
      short_name: string;
      category: string;
      image_search_term?: string;
      name: string;
      order_address: Address;
      sample_address: Address;
    };
    image: string;
    rfq_markdown: string;
    builder_step: BuilderStep | null;
    files: UploadedFile[];
    rfq_filter?: RfqSuitabilityFilter;
    organization?: number;
  };
}

// backend/rfq/serializers.py > RFQSerializer (fields from BaseRFQSerializer)
interface RFQ {
  id: number;
  author: number;
  document: {
    name: string;
    sizes: {
      default: string;
    };
    colors: {
      Body: string;
      Screen: string;
      Battery: string;
    };
    variants: any;
    materials: {
      Body: string;
      Screen: string;
      Battery: string;
    };
    aesthetics: any;
    short_name: string;
    description: string;
    contact_phone: any;
    order_address: any;
    key_components: any;
    sample_address: any;
    reference_sample: any;
    shipping_address: any;
    extra_information: {
      default: string;
    };
    technical_details: {
      SIM: string;
      Security: string;
      Connectivity: string;
    };
    suppliers_location: any;
    suppliers_location_exclude: any;
    number_of_units_per_variant: {
      default: number;
    };
    materials_derived_attributes: any;
    aesthetics_derived_attributes: any;
  };
  errors: Record<string, any>;
  questions: Array<{
    question: string;
    answer: string | null;
    question_type: string;
    options: any | null;
    suggested_answers: string[] | null;
    placeholder: any | null;
    comment: string | null;
    attribute: string;
    correct: boolean | null;
  }>;
  links: Record<string, any>;
  files_at_attributes: any;
  files: Array<any>;
  image: any;
  rfq_markdown: string;
  published: boolean;
  archived: boolean;
  created_at: string;
  updated_at: string;
  builder_step: BuilderStep | null;
}

export {
  type BuilderStep,
  type RFQ,
  type Rfq,
  RfqSuitabilityDecision,
  type RfqSuitabilityFilter
};
